import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInputUsername = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 12,
	viewBox: "0 0 17 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.09103 0H0V12H16.1787V0H8.09103ZM14.2977 1.57242L8.09103 5.72854L1.88439 1.57242H8.09103H14.2977ZM1.5776 10.4194V3.10225L8.09103 7.46144L14.6045 3.10225V10.4228H1.5776V10.4194Z",
		fill: "black"
	})
});
export default SvgInputUsername;
